'use strict';

// core version + modules:
import Swiper, { Navigation, A11y, Pagination } from "swiper";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';

const SliderMulti = {
    els: null,
    init: function () {
        SliderMulti.els = document.querySelectorAll('.f-slider.multi--');
        if (SliderMulti.els && SliderMulti.els.length > 0) {
            SliderMulti.els.forEach(el => {
                SliderMulti.create(el);
            });
        }
    },
    checkMargin: function (slider) {
        let images = slider.querySelectorAll(".c-img img");
        let maxHeight = 0;
        images.forEach(img => {
            if (img.clientHeight > maxHeight) {
                maxHeight = img.clientHeight;
            }
        });
        images.forEach(img => {
            img.style.marginTop = Math.floor(0.5 * (maxHeight - img.clientHeight)) + "px";
        });
    },
    create: function (el) {
        const slider = el.querySelector('.swiper');
        const nextEl = el.querySelector(".f-slider__navigation-next");
        const prevEl = el.querySelector(".f-slider__navigation-prev");
        const nextBtn = slider.dataset.prev ? slider.dataset.prev : "Navigate to prev slide";
        const prevBtn = slider.dataset.next ? slider.dataset.next : "Navigate to next slide";
        const paginationEl = el.querySelector(".f-slider__pagination");

        // Only focus the active slide's first link on a real user navigation
        // (arrows, pagination, swipe), never on internal transitions triggered on load
        let userNavigated = false;

        const modules = [A11y, Navigation, Pagination];
        const config = {
            modules: modules,
            spaceBetween: 10,
            slidesPerView: "auto",
            slidesPerGroup: 2,
            loop: false,
            speed: 600,
            autoHeight: false,
            breakpoints: {
                300: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    autoHeight: true,
                },
                767: {
                    // slidesPerView: 2,
                },
                992: {
                    // slidesPerView: 3
                }
            },
            a11y: {
                enabled: true,
                prevSlideMessage: nextBtn,
                nextSlideMessage: prevBtn,
                // Group role is on the wrapper (single group for the whole reel), not per slide
                slideRole: null,
            },
            on: {
                init: function () {

                    const swiper = this;
                    // Arrows visibility depends on whether the reel actually
                    // overflows. Computed here AND on every `update` (fired by
                    // swiper.update()): a slider that inits inside a hidden
                    // (display:none) tab measures its slides as 0-width and
                    // wrongly resolves to "everything fits" — arrows get hidden.
                    // Re-running on update (called by Tabs.js when the tab shows)
                    // restores them once real dimensions are known.
                    SliderMulti.updateCarouselState(swiper, slider, prevEl, nextEl);
                    // Name comes from the visible (visually-hidden) span in the markup,
                    // not from an aria-label — keeps it perceivable with CSS disabled.
                    prevEl?.removeAttribute('aria-label');
                    nextEl?.removeAttribute('aria-label');
                    SliderMulti.updateNavAvailability(swiper, prevEl, nextEl);
                    SliderMulti.updateFullyVisibleSlides(swiper);
                    SliderMulti.updateSlideAccessibility(swiper, true);

                    // Delegate on the pagination container (stable) rather than on
                    // each bullet: Swiper re-renders the bullets when the grid changes
                    // — which happens when the slider sits in a hidden tab that later
                    // shows — and listeners bound to the original bullets would be lost.
                    const paginationEl = swiper.pagination.el;
                    if (paginationEl) {
                        const goToBullet = bullet => {
                            const index = parseInt(bullet.getAttribute('data-slide-index'), 10);
                            userNavigated = true;
                            setTimeout(() => {
                                swiper.slideTo(index);
                            }, 0);
                        };

                        paginationEl.addEventListener('click', e => {
                            const bullet = e.target.closest('[data-slide-index]');
                            if (bullet && paginationEl.contains(bullet)) goToBullet(bullet);
                        });

                        paginationEl.addEventListener('keydown', e => {
                            if (e.key !== 'Enter' && e.key !== ' ') return;
                            const bullet = e.target.closest('[data-slide-index]');
                            if (bullet && paginationEl.contains(bullet)) {
                                e.preventDefault();
                                goToBullet(bullet);
                            }
                        });
                    }

                },
                update: function () {
                    SliderMulti.updateCarouselState(this, slider, prevEl, nextEl);
                    SliderMulti.updateNavAvailability(this, prevEl, nextEl);
                    SliderMulti.updateFullyVisibleSlides(this);
                },
                resize: function () {
                    SliderMulti.updateFullyVisibleSlides(this);
                },
                "toEdge fromEdge lock unlock": function () {
                    SliderMulti.updateNavAvailability(this, prevEl, nextEl);
                },
                slideChangeTransitionEnd: function() {
                    SliderMulti.updateFullyVisibleSlides(this);
                },
                transitionEnd() {
                    const swiper = this;
                    SliderMulti.updateSlideAccessibility(swiper, !userNavigated);
                    userNavigated = false;
                    swiper.slides.forEach((slide, index) => {
                        if (index !== swiper.activeIndex) {
                            SliderMulti.pauseMediaInSlide(slide);
                        }
                    });
                },
                touchEnd: function () {
                    userNavigated = true;
                }
            }
        };

        // Type de nav data-navigation
        if (slider.dataset.navigation === "arrows" && nextEl && prevEl) {
            config.navigation = {
                nextEl: nextEl,
                prevEl: prevEl,
            };
            nextEl.addEventListener('click', () => userNavigated = true);
            prevEl.addEventListener('click', () => userNavigated = true);
        }

        // Si pagination = true via data-pagination
        if (slider.dataset.pagination === "true" && paginationEl) {
            const labelPrefix = slider.dataset.go || 'Go to slide';
            config.pagination = {
                el: paginationEl,
                clickable: true,
                type: 'bullets',
                renderBullet: (index, className) => {
                    return `<li><span role="button" type="button" class="${className}" data-slide-index="${index}"  aria-label="${labelPrefix} ${index + 1}"><span class="visually-hidden">${index + 1}</span></span></li>`;
                }
            };
        }

        // permet de mettre plusieurs slide par group
        if (slider.dataset.slidePerGroup) {
            const slidePerGroup = parseInt(slider.dataset.slidePerGroup, 10);
            if (!isNaN(slidePerGroup) && slidePerGroup > 0) {
                config.slidesPerGroup = slidePerGroup;
            }
        }
        if (el.classList.contains("vertical--")) {
            config.centeredSlides = true;
        }
        const swiper = new Swiper(slider, config);
        slider.swiper = swiper;

        if (el.classList.contains("diapo--")) {
            document.addEventListener("resize", () => SliderMulti.checkMargin(slider));
            SliderMulti.checkMargin(slider);
        }

    },
    // Toggle arrows + carousel a11y roles based on whether the reel overflows.
    // Idempotent: safe to call on init and on every update (fired by swiper.update(),
    // which Tabs.js triggers when a hidden tab is shown).
    // We rely on Swiper's own overflow detection (isLocked) rather than
    // slides.length > slidesPerViewDynamic(): that test broke on centeredSlides
    // (the vertical variant) — a 2-slide reel returns spv=2, so 2 > 2 is false and
    // the arrows were hidden even though the 2nd slide sits off-screen. isLocked is
    // false whenever the reel can actually be navigated, which is exactly when we
    // want the arrows, and it's recomputed on every update once real sizes are known.
    updateCarouselState(swiper, slider, prevEl, nextEl) {
        const isCarousel = !swiper.isLocked;
        if (!isCarousel) {
            if (nextEl) nextEl.style.display = 'none';
            if (prevEl) prevEl.style.display = 'none';
        } else {
            // Reset the inline display set while hidden, so the arrows reappear.
            if (nextEl) nextEl.style.display = '';
            if (prevEl) prevEl.style.display = '';
            slider.setAttribute('role', 'region');
            slider.setAttribute('aria-roledescription', 'carrousel');
            if (slider.dataset.titleId) {
                slider.setAttribute('aria-labelledby', slider.dataset.titleId);
            } else if (slider.dataset.label) {
                slider.setAttribute('aria-label', slider.dataset.label);
            }
            // Single group for the whole reel, not one per slide
            slider.querySelector('.swiper-wrapper')?.setAttribute('role', 'group');
        }
        return isCarousel;
    },
    // Swiper only sets `disabled` on the boundary nav button — some AT still
    // expose disabled native buttons in browse mode, so hide them outright.
    updateNavAvailability(swiper, prevEl, nextEl) {
        if (swiper.params.loop) return;
        if (prevEl) prevEl.hidden = swiper.isBeginning;
        if (nextEl) nextEl.hidden = swiper.isEnd;
    },
    updateFullyVisibleSlides(swiper) {
        const swiperBounds = swiper.el.getBoundingClientRect();

        swiper.slides.forEach(slide => {
            const rect = slide.getBoundingClientRect();

            const slideWidth = rect.width;
            const visibleWidth = Math.min(rect.right, swiperBounds.right) - Math.max(rect.left, swiperBounds.left);
            const visibilityRatio = visibleWidth / slideWidth;

            // Si la slide est a moins de 80% visible ==> is-hidden
            const isMostlyHidden = visibilityRatio < 0.8;

            slide.classList.toggle('is-hidden', isMostlyHidden);
        });
    },
    updateSlideAccessibility(swiper, isTheInit=false) { //fonction accessibilité : enpecher focus sur slides masquées
        swiper.slides.forEach((slide, index) => {
            const isActive = index === swiper.activeIndex;

            slide.setAttribute('aria-hidden', String(!isActive));
            slide.removeAttribute('role');

            const focusable = slide.querySelectorAll('a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
            focusable.forEach(el => {
                if (isActive) {
                    el.removeAttribute('tabindex');
                    el.removeAttribute('aria-hidden');
                    el.removeAttribute('aria-disabled');
                } else {
                    el.setAttribute('tabindex', '-1');
                    el.setAttribute('aria-hidden', 'true');
                    el.removeAttribute('aria-disabled');
                }
            });
        });

        // Donne le focus au premier lien/cta de la slide active ==> uniquement au slide et pas au init
        if (!isTheInit) {
            const activeSlide = swiper.slides[swiper.activeIndex];
            if (activeSlide) {
                const firstLink = activeSlide.querySelector('a, button, input, textarea, select, [tabindex]');
                if (firstLink) {
                    setTimeout(() => {
                        firstLink.focus();
                    }, 100);
                }
            }
        }
    },
    pauseMediaInSlide(slide) {
        slide.querySelector(".c-video__player-poster")?.classList.remove('hidden')
        // Pause MP4
        const videos = slide.querySelectorAll('video');
        videos.forEach(video => {
            if (!video.paused) {
                video.pause();
            }
        });

        // Traite les iframes (YouTube, Dailymotion, etc.)
        const iframes = slide.querySelectorAll('iframe');
        iframes.forEach(oldIframe => {
            let src = oldIframe.getAttribute('src') || '';

            // Enleve d'autoplay dans l'URL
            src = src
                .replace(/([?&])autoplay=1/, '$1autoplay=0')
                .replace(/([?&])autoPlay=1/, '$1autoPlay=0');
            src = src.replace(/[?&]+$/, '').replace(/\?&/, '?');

            // Crée un nouvel iframe 
            const newIframe = oldIframe.cloneNode(true);
            newIframe.setAttribute('src', src);
            newIframe.setAttribute('allow', 'fullscreen; encrypted-media');

            // Remplace l'ancien iframe
            oldIframe.replaceWith(newIframe);
        });
    }
};

export default SliderMulti;